import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { ToastMessageService } from '@core/services/toast-message.service';
import { inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private toast = inject(ToastMessageService);

  private lastToastTime = 0;
  private DEBOUNCE_TIME = 3000;

  handleError(error: HttpErrorResponse, entityName: string) {
    const now = Date.now();
    if (now - this.lastToastTime < this.DEBOUNCE_TIME) {
      return throwError(() => new Error('Error duplicado ignorado'));
    }
    this.lastToastTime = now;

    let errorMessage = `Ha ocurrido un error inesperado con ${entityName}.`;
    if (error.error instanceof ErrorEvent) {
      errorMessage = 'Ha ocurrido un error inesperado';
    } else {
      switch (error.status) {
        case 400:
          errorMessage = 'Error de validación.';
          break;
        case 401:
          errorMessage = 'No autorizado. Por favor inicie sesión.';
          break;
        case 403:
          errorMessage = 'No tiene permisos para esta acción.';
          break;
        case 500:
          errorMessage = 'Error interno del servidor.';
          break;
      }
    }

    if (error.status === 401 || error.status === 403) {
      this.toast.showWarn('Advertencia', errorMessage);
    }

    return throwError(() => ({
      message: errorMessage,
      data: error.error?.data,
      status: error.status,
    }));
  }
}
